module.exports = __webpack_public_path__ + "img/home3.09d3e4b0.jpg";